<template>
  <v-layout class="mt-3">
    <v-menu
      ref="datePicker"
      :close-on-content-click="false"
      v-model="picker"
      :nudge-right="40"
      class="mr-3 mt-4"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px">
      <v-icon slot="activator">calendar_today</v-icon>
      <v-date-picker
        :locale="locale"
        :value="dateValue"
        :allowed-dates="allowedDates"
        :min="min"
        :max="max"
        type="date"
        no-title
        @input="savePicked"
      />
    </v-menu>
    <v-text-field
      v-model="typedValue"
      :label="label"
      :rules="rules"
      :error-messages="errorMessages"
      :placeholder="placeholder"
      mask="##.##.####"
      clearable
      @change="saveTyped"
    />
  </v-layout>
</template>

<script>

const dateFormatVisible = 'DD.MM.YYYY'
const dateFormatInternal = 'YYYY-MM-DD'
const dateFormatMasked = 'DDMMYYYY'

export default {
  name: 'DatePicker',
  props: ['value', 'label', 'errorMessages', 'rules', 'allowedDates', 'min', 'max'],
  data () {
    return {
      dateValue: null,
      typedValue: null,
      picker: false
    }
  },
  computed: {
    placeholder () {
      return this.$moment()
        .format(dateFormatVisible)
    },
    locale () {
      return `${localStorage.locale}-${localStorage.locale}`
    }
  },
  methods: {
    checkTypedValue (value) {
      const $date = this.$moment(value, dateFormatMasked)
      const isValid = $date.isValid()
      if (this.isAllowed) {
        // when isAllowed function is passed, use it for validation
        return isValid && this.isAllowed($date.format(dateFormatInternal))
      }

      // todo: add min/max validations for typed values
      return isValid
    },

    saveTyped (value) {
      // for typed values make a check if it works, then pass it to save function
      if (this.checkTypedValue(value)) {
        const date = this.$moment(value, dateFormatMasked).format(dateFormatInternal)
        return this.save(date)
      } else {
        return this.save(null) // when user typed some invalid date, reset the field
      }
    },
    savePicked (value) {
      // picked dates are always correct and already in internal format
      return this.save(value)
    },
    save (value) {
      this.$emit('input', value)
      this.picker = false
    }

  },
  watch: {
    value: {
      handler (value) {
        this.dateValue = null
        this.typedValue = null
        const $date = this.$moment(value)

        if ($date.isValid()) {
          this.dateValue = $date.format(dateFormatInternal)
          this.typedValue = $date.format(dateFormatMasked)
        }
      },
      immediate: true
    }
  }
}
</script>
